export default {
  fields: {
    online_shop_domain: 'Dominio propio para la tienda online',
    online_shop_domain_hint:
      'Un dominio del restaurante, por ejemplo order.pizzeria-mario.com — solo para pedidos; un sitio web necesita otro distinto. Una vez guardado, aquí se muestran los registros que hay que añadir.',
    online_shop_domain_placeholder: 'order.pizzeria-mario.com',
  },
};
